<template>
    <div class="modal is-active" >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title " v-if="dataToChild" >Reset Password <strong> {{ name }} {{ surname }} </strong>!!!!</p>
                <figure class="image is-48x48" v-if="avartar">
                    <img  :src="avartar" alt="Image" v-if="avartar">
                </figure> &nbsp;
<!--                <button class="delete" aria-label="close" @click="closeBtn"></button>-->
            </header>
            <section class="modal-card-body">
                <!-- Content ... -->
                <div class="notification is-warning" v-if="dataToChild">
                    Data will be reset password!!!, Are you sure to reset that?
                </div>

                <b-field label="Name">
                    <b-input type="text"
                             v-model="name" disabled>
                    </b-input>
                </b-field>


                <b-field label="Surname">
                    <b-input type="text"
                             v-model="surname" disabled>
                    </b-input>
                </b-field>


                <b-field label="Email">
                    <b-input type="email"
                             v-model="email" disabled>
                    </b-input>
                </b-field>

                <b-field label="Password"
                         :type="{ 'is-danger': ( !this.$v.password.required && !first)}"
                         :message="{ 'Password have require and failure to validations':( !this.$v.password.required && !first) }"
                >
                    <b-input type="password"
                             v-model="password"
                             password-reveal
                    >
                    </b-input>

                </b-field>


                <b-field label="Password Again"
                         :type="{ 'is-danger': ( !this.$v.password.required && !first)}"
                         :message="{ 'Password have require and failure to validations':( !this.$v.password.required && !first) }"
                >
                    <b-input type="password"
                             v-model="password1"
                             password-reveal
                    >
                    </b-input>

                </b-field>

                <b-message type="is-danger" v-if="!PasswordMatch  ">
                   Password not match
                </b-message>

            </section>
            <footer class="modal-card-foot">
                <b-button type="is-danger"  @click="closeBtn">Close</b-button>

<!--                <button class="button" @click="closeBtn">Cancel</button>-->
                &nbsp;
                <b-button type="is-success"  @click="updatePass">Save&Update</b-button>

<!--                <button class="button" @click="updatePass" type="is-success" >Save&Update</button>-->

            </footer>
        </div>
    </div>
</template>

<script>
    /* eslint-disable no-console */
    // import axios from "axios"

    import axios from "axios"
    import { getBaseURLforBackEnd  , getConfigAxios , getBaseURLAvartar }  from '@/utils.js'
    import {required} from "vuelidate/lib/validators";
    import sha512 from "js-sha512";
    import {mapState} from "vuex";

    export default {
        name: "DlgResetPassword",
        created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.closeBtn()

                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
        },
        mounted() {
            // console.log(this.dataToChild)
            if(!this.user_id){
                this.$router.push('/login')
                    .catch(()=>{});
                return
            }


            const  vm = this
            const dat ={
                "user_id" : this.dataToChild
            }
            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
            axios.post(`${getBaseURLforBackEnd()}/api/getinfouser`,dat , getConfigAxios())
                 .then((res)=>{
                     if(res.data.avartar_path) {
                         const urlAvartar = `${getBaseURLAvartar()}/user_${res.data.id}/${res.data.avartar_path}`
                         vm.avartar = urlAvartar
                     }
                     vm.name = res.data.name
                     vm.surname = res.data.surname
                     if(res.data.email) {
                         vm.email = res.data.email
                     }
                 })
        },
        props:{
            dataToChild : null ,
        },
        validations: {
            password: {
                required
            }
        },
        computed: {
            ...mapState({
                user_id: state => state.master_data.user_id,
                access_token: state => state.master_data.access_token,
            }),
        },
        data(){
            return {
                password : '',
                password1 : '',
                PasswordMatch : true,
                avartar : null ,
                name : '',
                surname: '',
                email: '',
                first : true ,
            }
        },
        methods:{

            closeBtn(){
                this.$emit('close')
            },
            updatePass(){
                if(!this.$v.password.required ){
                    this.first = false
                }else{
                     // console.log('ok')
                    const vm =this
                    const dat =
                         {
                        "iduser" : this.dataToChild,
                        "passenc": sha512(sha512(this.password))
                        //  "passenc": sha512(this.password)
                         }
                    // console.log(JSON.stringify(dat))
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                    axios.post(`${getBaseURLforBackEnd()}/api/updatepassenc_email`,dat , getConfigAxios())
                      .then((res)=>{
                          // console.log(res.data)
                          vm.$buefy.dialog.alert({
                              title: 'Success to update',
                              message: ` ${res.data.status}` ,
                              type: 'is-success',
                              hasIcon: true,

                          })
                          vm.closeBtn()

                      })
                      .catch((err)=>{
                           // console.log(err)
                           vm.$buefy.dialog.alert({
                              title: 'Error',
                              message: `Error ${err.response.data.dat}` ,
                              type: 'is-danger',
                              hasIcon: true,
                              icon: 'times-circle',
                              iconPack: 'fa',
                              ariaRole: 'alertdialog',
                              ariaModal: true
                          })
                          vm.closeBtn()
                      })
                }
            }
        } ,
        watch: {
            password: {
                handler: function (val) {
                    val === this.password1  ?  this.PasswordMatch = true : this.PasswordMatch = false

                }
            } ,
            password1: {
                handler: function (val1) {
                    val1 === this.password  ?  this.PasswordMatch = true : this.PasswordMatch = false
                }
            }
        } ,

    }
</script>

<style scoped>

</style>